// @ts-check
import React from 'react';
import { Box, useTheme, Title } from '../../../pdf-design-system';
import useRoom from '../useRoom';
// @ts-ignore Images are not allowed currently.
// import roomPlan from '../Stencil/vievinum-room-plan.png';
// import { Image } from '@react-pdf/renderer';

export default function RoomPlan() {
  const room = useRoom();
  const { theme } = useTheme();
  return (
    <>
      <Box style={{ marginHorizontal: '-12mm' }}>
        <Box
          style={{
            backgroundColor: theme.colors.primary,
            color: theme.colors.onPrimary,
            paddingLeft: '12mm',
            paddingRight: '8mm',
            paddingTop: '1.5mm',
            paddingBottom: '2mm',
          }}
        >
          <Title variant="larger" style={{ fontSize: 20 }}>
            {room?.name}
          </Title>
        </Box>
        <Box
          style={{
            color: theme.colors.primary,
            paddingLeft: '12mm',
            paddingRight: '8mm',
            paddingVertical: '2mm',
          }}
        >
          <Title>{room?.subtitle}</Title>
        </Box>
      </Box>
      {/* <Image
        src={roomPlan}
        style={{
          opacity: 0.5,
          position: 'absolute',
          top: 0,
          left: 0,
          height: '234mm',
          width: '162mm',
        }}
      /> */}
    </>
  );
}
